import { client } from "./services/client";

export const webhooks = {
  namespaced: true,
  state: {
    webhooks: [],
  },
  mutations: {
    SET_WEBHOOK(state, webhooks) {
      state.webhooks = webhooks;
    },
  },
  actions: {
    get({ commit }, marchand_id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/webhook/get/" + marchand_id,
        })
          .then((response) => {
            let webhooks = response.data.webhooks;
            commit("SET_WEBHOOK", webhooks);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    set({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "post",
          url: "/webhook/save",
          data: data,
        })
          .then((response) => {
            let webhooks = response.data.webhooks;
            commit("SET_WEBHOOK", webhooks);

            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    delete({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/webhook/delete/" + id,
        })
          .then((response) => {
            let webhooks = response.data.webhooks;
            commit("SET_WEBHOOK", webhooks);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  getters: {
    get: (state) => {
      return state.category_marchands;
    },
  },
};
